import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/shadcn/dialog';

import { DiffViewer } from '@/components/monaco/diffViewer/diffViewer';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  before: unknown;
  after: unknown;
};

export const TableRowDiffViewer = ({
  open,
  onOpenChange,
  before,
  after
}: Props) => (
  <Dialog onOpenChange={onOpenChange} open={open}>
    <DialogContent className="flex h-[80vh] w-full max-w-11/12 flex-col overflow-hidden p-0">
      <DialogHeader className="shrink-0 px-6 pt-6">
        <DialogTitle>Differences between rows</DialogTitle>
      </DialogHeader>
      <DiffViewer after={after} before={before} className="min-h-0 flex-1" />
    </DialogContent>
  </Dialog>
);
